import defaultIndex from './defaults/index.json';
import merge from 'lodash/merge';
let actualIndex;

export function reset() {
  actualIndex = undefined;
}

export function hasIndex() {
  if (actualIndex) {
    return Promise.resolve(actualIndex === defaultIndex);
  }

  return fetch('/public/custom/index.json?r=' + new Date().getTime()).then((res) => res.ok);
}

export function getDefaultIndex() {
  return defaultIndex;
}

export function getIndex() {
  if (actualIndex) {
    return Promise.resolve(merge({}, defaultIndex, actualIndex));
  }

  return fetch('/public/custom/index.json?r=' + new Date().getTime())
    .then((res) => {
      if (!res.ok) {
        return Promise.resolve(merge({}, defaultIndex));
      }

      return res.json();
    })
    .then((json) => {
      actualIndex = json;
      Object.keys(actualIndex).forEach((k) => {
        if (!defaultIndex[k]) {
          defaultIndex[k] = merge({}, defaultIndex.standalone, actualIndex.dashboard);
        }
      });
      // console.log(merge({}, defaultIndex, actualIndex));
      return Promise.resolve(merge({}, defaultIndex, actualIndex));
    });
}

export function getIndexDiff(newIndex) {
  return _.reduceDeep(
    newIndex,
    (res, v, k, p, { path }) => {
      if (v && path && _.get(defaultIndex, path) !== v) {
        _.set(res, path, v);
      }

      return res;
    },
    {},
    { leavesOnly: true }
  );
}
